/**
 * Calculates the total amount due for an invoice based on the invoice amount and client service fee.
 *
 * @param input - An object that contains two properties: amountToInvoice and clientServiceFee.
 * @param input.amountToInvoice - The invoice amount as a string, input by the user.
 * @param input.clientServiceFee - The client service fee as a number.
 *
 * @returns The total amount due for the invoice as a number.
 */

interface InvoiceInput {
  amountToInvoice: string;
  clientServiceFee: number;
}

export const getInvoiceAmountDue = (input: InvoiceInput): number => {
  const { amountToInvoice, clientServiceFee } = input;

  if (!amountToInvoice || isNaN(Number(amountToInvoice))) {
    return 0;
  }

  const parsedAmount = parseFloat(amountToInvoice);

  return parsedAmount !== 0 ? clientServiceFee + parsedAmount : 0;
};
